import AppSettings from '../../../AppSettings';
// Librairies
import i18n from '../../../locales/i18n';

const BACKEND_ENDPOINT = AppSettings.getBackendUrl();
const normalizeLabel = (label) => (label || '').trim().toUpperCase();

// Tags marqués comme jamais créés : retirés des éléments qui les portent (ElementRefs)
export const forgetLocalTags = async (idMap, tags) => {
    for (const tag of tags) await idMap?.set('tag', tag.id, false);
};

export const tagHandlers = {
    'tag.create': {
        describe: op => i18n.t("Ajout de tags ({{labels}})", { labels: op.payload.tags.map(tag => tag.label).join(', ') }),
        buildRequest: async (op) => ({ request: { method: 'post', url: `${BACKEND_ENDPOINT}projects/tags/`, data: op.payload.tags } }),
        // L'API n'ajoute pas un libellé qui existe déjà dans le projet : les éléments prennent l'id du tag existant
        onSuccess: async (op, response, context) => {
            const projectTags = Array.isArray(response.data) ? response.data : [];
            for (const tag of op.payload.tags) {
                const serverTag = projectTags.find(t => normalizeLabel(t.label) === normalizeLabel(tag.label) && t.category === tag.category);
                if (serverTag && serverTag.id !== tag.id) await context.idMap.set('tag', tag.id, serverTag.id);
            }
            return { projectTags };
        },
        onAbandon: (op, context) => forgetLocalTags(context.idMap, op.payload.tags)
    }
};
